/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiBaseService } from '../dapi-base-service';
import { DapiHttpResponse } from '../dapi-http-response';
import { DapiRequestBuilder } from '../dapi-request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FinnairAdvancePassengerInformationRequest } from '../models/finnair-advance-passenger-information-request';


/**
 * APIS details
 */
@Injectable({
  providedIn: 'root',
})
export class AdvancePassengerInformationService extends DapiBaseService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  /**
   * Path part for operation updateAdvancePassengerInformation
   */
  static readonly UpdateAdvancePassengerInformationPath = '/api/v2/order/{orderId}/advance-passenger-information';

  /**
   * postAdvancePassengerInformation.
   *
   * Adds/Updates advance passenger information to the order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdvancePassengerInformation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdvancePassengerInformation$Response(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: Array<FinnairAdvancePassengerInformationRequest>
  }): Observable<DapiHttpResponse<void>> {
    const rb = new DapiRequestBuilder(rootUrl, AdvancePassengerInformationService.UpdateAdvancePassengerInformationPath, 'post');

    if (params) {
      rb.path('orderId', params.orderId, {});
      rb.query('hash', params.hash, {});
      rb.query('locale', params.locale, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
      }),
      catchErrorAsJson()
    );
  }

  /**
   * postAdvancePassengerInformation.
   *
   * Adds/Updates advance passenger information to the order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAdvancePassengerInformation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdvancePassengerInformation(rootUrl: string, params: {
    orderId: string;
    hash?: string;
    locale?: string;
    body: Array<FinnairAdvancePassengerInformationRequest>
  }): Observable<void> {
    return this.updateAdvancePassengerInformation$Response(rootUrl, params).pipe(
      map((r: DapiHttpResponse<void>) => r.body as void)
    );
  }

}
